import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import ScrollToTop from './components/base/ScrollToTop'
import FloatingCallButton from './components/base/FloatingCallButton'

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <AppRoutes />
      <FloatingCallButton />
    </BrowserRouter>
  )
}

export default App